/**
 * The starter library: what the home offers a user who has nothing yet. The
 * templates are D5 in the onboarding spec, five canvases published by
 * Cohesive Templates and mirrored into every environment key for key, so one
 * id resolves everywhere.
 */

export interface Template {
  id: string;
  title: string;
  /** One line on what the canvas is about, under the title. */
  tagline: string;
}

export const TEMPLATES: readonly Template[] = [
  {
    id: "4c60fa8a-2c9f-4214-b91a-251054208c24",
    title: "News Headlines Evolution",
    tagline: "How news headlines grew darker from 2008 to 2026",
  },
  {
    id: "9f79f319-97c2-4704-9c88-62f44a27756a",
    title: "F1 Data Canvas",
    tagline: "The 2026 Italian GP from the data: replay and pace",
  },
  {
    id: "4882547c-8868-47ab-9279-dee9f1405006",
    title: "10-inch Rack Retrofit",
    tagline: "Turning an IKEA cabinet into a 10-inch server rack",
  },
  {
    id: "a96a6de6-77eb-4459-97aa-a1753796b6ce",
    title: "Blood Moon",
    tagline: "The 28 August 2026 eclipse to scale, with timings",
  },
  {
    id: "483fe563-5d38-4220-963d-200bc5c29aaf",
    title: "Marathon Training",
    tagline: "Sixteen weeks to a 3:45 at CIM, pacing to fueling",
  },
];
